import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { allowFreeText } from '@bibliocommons/utils-user';
import { setFocusWithinElement } from '@bibliocommons/utils-accessibility';

import {
  bibShape,
  shelfItemShape,
  userIdentityShape,
  ugcCommentShape,
  ugcQuotationShape,
  ugcRatingShape,
  ugcTagShape,
  ugcVideoShape,
  ugcSimilarTitlesShape,
  ugcPrivateNoteShape
} from '@bibliocommons/bc-prop-types';

import CommentInfo from '../CommentInfo';
import QuotationsInfo from '../QuotationsInfo';
import RatingsInfo from '../RatingsInfo';
import TagsInfo from '../TagsInfo';
import VideoInfo from '../VideoInfo';
import Toolbar from '../Toolbar';
import SimilarTitlesInfo from '../SimilarTitlesInfo';
import PrivateNoteInfo from '../PrivateNoteInfo';

import './FooterInfo.scss';

export default class ShelfListItemFooterInfo extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('handleUGCFocus');

    this.commentInfoRef = null;
    this.quotationsInfoRef = null;
    this.tagsInfoRef = null;
    this.videoInfoRef = null;

    this.state = {
      commentAdded: false,
      quotationsAdded: false,
      tagsAdded: false,
      videoAdded: false,
      similarTitlesAdded: false,
      privateNoteAdded: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const {
      ownerCommentForBib,
      ownerQuotationsForBib,
      ownerTagsForBib,
      ownerVideoForBib,
      ownerSimilarTitlesForBib,
      ownerPrivateNoteForBib
    } = this.props;

    const tagsCount = ownerTagsForBib ? ownerTagsForBib.size : 0;
    const nextTagsCount = nextProps.ownerTagsForBib ? nextProps.ownerTagsForBib.size : 0;
    const quotationsCount = ownerQuotationsForBib ? ownerQuotationsForBib.size : 0;
    const nextQuotationsCount = nextProps.ownerQuotationsForBib ? nextProps.ownerQuotationsForBib.size : 0;
    const similarTitlesCount = ownerSimilarTitlesForBib ? ownerSimilarTitlesForBib.size : 0;
    const nextSimilarTitlesCount = nextProps.ownerSimilarTitlesForBib ? nextProps.ownerSimilarTitlesForBib.size : 0;

    this.setState({
      commentAdded: nextProps.ownerCommentForBib && !ownerCommentForBib,
      quotationsAdded: nextQuotationsCount > quotationsCount,
      tagsAdded: nextTagsCount > tagsCount,
      videoAdded: nextProps.ownerVideoForBib && !ownerVideoForBib,
      similarTitlesAdded: nextSimilarTitlesCount > similarTitlesCount,
      privateNoteAdded: nextProps.ownerPrivateNoteForBib && !ownerPrivateNoteForBib
    });
  }

  handleUGCFocus(previouslyFocusedElement) {
    const { commentAdded, quotationsAdded, tagsAdded, videoAdded, similarTitlesAdded, privateNoteAdded } = this.state;

    setTimeout(() => {
      if (commentAdded && this.commentInfoRef) {
        return setFocusWithinElement(this.commentInfoRef);
      }

      if (quotationsAdded && this.quotationsInfoRef) {
        return setFocusWithinElement(this.quotationsInfoRef);
      }

      if (tagsAdded && this.tagsInfoRef) {
        return setFocusWithinElement(this.tagsInfoRef);
      }

      if (videoAdded && this.videoInfoRef) {
        return setFocusWithinElement(this.videoInfoRef);
      }

      if (similarTitlesAdded && this.similarTitlesInfoRef) {
        return setFocusWithinElement(this.similarTitlesInfoRef);
      }

      if (privateNoteAdded && this.privateNoteInfoRef) {
        return setFocusWithinElement(this.privateNoteInfoRef);
      }

      return previouslyFocusedElement.focus();
    }, 0);
  }

  renderToolbar() {
    const { owner } = this.props;
    if (owner.get('loggedIn') && allowFreeText(owner)) {
      return (
        <Toolbar
          bib={this.props.bib}
          item={this.props.item}
          owner={this.props.owner}
          currentLibrary={this.props.currentLibrary}
          localBranch={this.props.localBranch}
          ownerCommentForBib={this.props.ownerCommentForBib}
          ownerTagsForBib={this.props.ownerTagsForBib}
          ownerVideoForBib={this.props.ownerVideoForBib}
          similarTitleBibs={this.props.similarTitleBibs}
          ownerPrivateNoteForBib={this.props.ownerPrivateNoteForBib}
          commentsTransactions={this.props.commentsTransactions}
          quotationsTransactions={this.props.quotationsTransactions}
          shelfTransactions={this.props.shelfTransactions}
          tagsTransactions={this.props.tagsTransactions}
          videosTransactions={this.props.videosTransactions}
          similarTitlesTransactions={this.props.similarTitlesTransactions}
          privateNotesTransactions={this.props.privateNotesTransactions}
          commentsActions={this.props.commentsActions}
          quotationsActions={this.props.quotationsActions}
          shelfActions={this.props.shelfActions}
          tagsActions={this.props.tagsActions}
          videosActions={this.props.videosActions}
          similarTitlesActions={this.props.similarTitlesActions}
          privateNotesActions={this.props.privateNotesActions}
          handleUGCFocus={this.handleUGCFocus} />
      );
    }

    return null;
  }

  render() {
    const {
      bib,
      owner,
      item,
      shelfName,
      currentLibrary,
      localBranch,
      ownerCommentForBib,
      ownerQuotationsForBib,
      ownerRatingForBib,
      ownerTagsForBib,
      ownerVideoForBib,
      ownerSimilarTitlesForBib,
      ownerPrivateNoteForBib,
      similarTitleBibs,
      commentsTransactions,
      quotationsTransactions,
      ratingsTransactions,
      shelfTransactions,
      tagsTransactions,
      videosTransactions,
      similarTitlesTransactions,
      privateNotesTransactions,
      commentsActions,
      quotationsActions,
      ratingsActions,
      shelfActions,
      tagsActions,
      videosActions,
      similarTitlesActions,
      privateNotesActions
    } = this.props;

    return (
      <div className="cp-shelf-list-item-footer-info">
        <div className="ugc-info">
          <RatingsInfo
            owner={owner}
            item={item}
            shelfName={shelfName}
            ownerRatingForBib={ownerRatingForBib}
            ratingsTransactions={ratingsTransactions}
            ratingsActions={ratingsActions} />
          <CommentInfo
            bib={bib}
            item={item}
            owner={owner}
            currentLibrary={currentLibrary}
            localBranch={localBranch}
            ownerCommentForBib={ownerCommentForBib}
            commentsTransactions={commentsTransactions}
            shelfTransactions={shelfTransactions}
            commentsActions={commentsActions}
            shelfActions={shelfActions}
            ref={(el) => { this.commentInfoRef = el; }} />
          <TagsInfo
            bib={bib}
            owner={owner}
            currentLibrary={currentLibrary}
            localBranch={localBranch}
            ownerTagsForBib={ownerTagsForBib}
            tagsTransactions={tagsTransactions}
            tagsActions={tagsActions}
            ref={(el) => { this.tagsInfoRef = el; }} />
          <QuotationsInfo
            bib={bib}
            item={item}
            owner={owner}
            currentLibrary={currentLibrary}
            localBranch={localBranch}
            ownerQuotationsForBib={ownerQuotationsForBib}
            quotationsTransactions={quotationsTransactions}
            shelfTransactions={shelfTransactions}
            quotationsActions={quotationsActions}
            shelfActions={shelfActions}
            ref={(el) => { this.quotationsInfoRef = el; }} />
          <VideoInfo
            bib={bib}
            item={item}
            owner={owner}
            currentLibrary={currentLibrary}
            localBranch={localBranch}
            ownerVideoForBib={ownerVideoForBib}
            shelfTransactions={shelfTransactions}
            videosActions={videosActions}
            videosTransactions={videosTransactions}
            shelfActions={shelfActions}
            ref={(el) => { this.videoInfoRef = el; }} />
          <SimilarTitlesInfo
            bib={bib}
            item={item}
            owner={owner}
            currentLibrary={currentLibrary}
            localBranch={localBranch}
            similarTitleBibs={similarTitleBibs}
            ownerSimilarTitlesForBib={ownerSimilarTitlesForBib}
            similarTitlesActions={similarTitlesActions}
            similarTitlesTransactions={similarTitlesTransactions}
            shelfActions={shelfActions}
            shelfTransactions={shelfTransactions}
            ref={(el) => { this.similarTitlesInfoRef = el; }} />
          <PrivateNoteInfo
            bib={bib}
            item={item}
            owner={owner}
            currentLibrary={currentLibrary}
            localBranch={localBranch}
            ownerPrivateNoteForBib={ownerPrivateNoteForBib}
            privateNotesTransactions={privateNotesTransactions}
            shelfTransactions={shelfTransactions}
            privateNotesActions={privateNotesActions}
            shelfActions={shelfActions}
            ref={(el) => { this.privateNoteInfoRef = el; }} />
        </div>
        {this.renderToolbar()}
      </div>
    );
  }
}

ShelfListItemFooterInfo.propTypes = {
  bib: bibShape.isRequired,
  currentLibrary: ImmutablePropTypes.map.isRequired,
  owner: userIdentityShape.isRequired,
  item: shelfItemShape.isRequired,
  shelfName: PropTypes.string.isRequired,
  localBranch: PropTypes.string,
  ownerCommentForBib: ugcCommentShape,
  ownerQuotationsForBib: ImmutablePropTypes.listOf(ugcQuotationShape),
  ownerRatingForBib: ugcRatingShape,
  ownerVideoForBib: ugcVideoShape,
  ownerSimilarTitlesForBib: ImmutablePropTypes.listOf(ugcSimilarTitlesShape),
  similarTitleBibs: ImmutablePropTypes.map,
  ownerTagsForBib: ImmutablePropTypes.listOf(ugcTagShape),
  ownerPrivateNoteForBib: ugcPrivateNoteShape,
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  ratingsTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  tagsTransactions: ImmutablePropTypes.map.isRequired,
  videosTransactions: ImmutablePropTypes.map.isRequired,
  similarTitlesTransactions: ImmutablePropTypes.map.isRequired,
  privateNotesTransactions: ImmutablePropTypes.map.isRequired,
  commentsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  quotationsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  ratingsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  tagsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  videosActions: PropTypes.objectOf(PropTypes.func).isRequired,
  similarTitlesActions: PropTypes.objectOf(PropTypes.func).isRequired,
  privateNotesActions: PropTypes.objectOf(PropTypes.func).isRequired
};



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/FooterInfo/FooterInfo.jsx